import { z } from "zod";
import { IsoDateTimeSchema } from "./common.js";
/**
 * Chaves do alfa fechado.
 *
 * Enquanto o jogo está em alfa, criar conta exige uma chave. O painel gera, a
 * pessoa digita na criação da conta, e a primeira que digitar consome: cada
 * chave vale uma vez.
 *
 * **O formato é fixo e conferido dos dois lados.** `LFM-XXXX-XXXX`, com letras
 * e números sem os caracteres que se confundem lidos em voz alta ou copiados de
 * uma captura de tela. Uma chave chega por WhatsApp e é digitada à mão, então
 * `0` e `O`, `1` e `I` juntos no mesmo alfabeto seriam suporte todo dia.
 */
/** O alfabeto das chaves, sem `0`, `O`, `1`, `I` e `L`. */
export const ALFABETO_DA_CHAVE = "23456789ABCDEFGHJKMNPQRSTUVWXYZ";
/** `LFM-4CHM-9XQ2`. O prefixo existe para a chave se reconhecer fora de contexto. */
export const ALPHA_KEY_REGEX = /^LFM-[23456789ABCDEFGHJKMNPQRSTUVWXYZ]{4}-[23456789ABCDEFGHJKMNPQRSTUVWXYZ]{4}$/;
/**
 * A chave como ela chega do formulário.
 *
 * Aceita minúscula e espaço em volta porque quem cola de uma conversa traz os
 * dois, e recusar por isso seria implicância. O `transform` normaliza antes da
 * conferência de formato, então o servidor guarda e compara sempre maiúscula.
 */
export const AlphaKeySchema = z
    .string()
    .trim()
    .toUpperCase()
    .regex(ALPHA_KEY_REGEX, "Chave fora do formato LFM-XXXX-XXXX.");
/** Uma chave, como o painel a vê. */
export const AlphaKeyRowSchema = z.object({
    code: z.string(),
    createdById: z.string(),
    createdAt: IsoDateTimeSchema,
    note: z.string().nullable(),
    usedById: z.string().nullable(),
    usedAt: IsoDateTimeSchema.nullable(),
    /** O nome de quem usou, para o painel não precisar de uma segunda consulta. */
    usedByName: z.string().nullable(),
});
/** `POST /admin/alpha-keys`. */
export const GerarAlphaKeysRequestSchema = z
    .object({
    /** Quantas de uma vez. O teto existe para um dedo escorregado não gerar mil. */
    quantidade: z.number().int().min(1).max(50).default(1),
    note: z.string().trim().max(120).optional(),
})
    .strict();
export const AlphaKeysResponseSchema = z.object({
    keys: z.array(AlphaKeyRowSchema),
    resumo: z.object({
        total: z.number().int(),
        livres: z.number().int(),
        usadas: z.number().int(),
    }),
});
//# sourceMappingURL=alpha.js.map